import { render, staticRenderFns } from "./items-type-pdr.vue?vue&type=template&id=85a803ce&scoped=true&"
import script from "./items-type-pdr.vue?vue&type=script&lang=js&"
export * from "./items-type-pdr.vue?vue&type=script&lang=js&"
import style0 from "./items-type-pdr.vue?vue&type=style&index=0&id=85a803ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a803ce",
  null
  
)

export default component.exports